<div class="catalog-page" [class.catalog-page--guest]="!isLoggedIn()">
    <ng-container *ngIf="isLoggedIn(); else guestHeader">
        <header class="o360-page-header">
            <div class="o360-page-header__main">
                <div class="o360-page-header__context">{{ contextName }}</div>
                <h1>Catálogo</h1>
            </div>

            <div class="o360-page-header__actions">
                <button
                    mat-stroked-button
                    type="button"
                    class="catalog-page__cart-button"
                    (click)="toggleQuoteSidebar()">
                    <mat-icon
                        [ngClass]="{ 'animate-cart-bounce': cartShouldBounce }"
                        (animationend)="cartShouldBounce = false">
                        shopping_cart
                    </mat-icon>
                    <span>Orçamento</span>
                    <span class="catalog-page__cart-badge">{{ quoteItemsCount }}</span>
                </button>
            </div>
        </header>
    </ng-container>

    <ng-template #guestHeader>
        <header class="catalog-page__guest-header">
            <div class="catalog-page__guest-brand">
                <img src="../../assets/images/logo/O360.svg" alt="Organiza360" class="catalog-page__guest-logo" />
                <span>Organiza360</span>
            </div>

            <button routerLink="/" class="catalog-page__guest-link">
                Entrar / Criar conta
            </button>
        </header>

        <section class="catalog-page__guest-banner">
            <p>
                <strong>Crie a sua conta gratuitamente</strong> e experimente a gestão de eventos por <strong>7 dias sem limitações</strong>.
                Explore o catálogo e peça o seu orçamento sem compromisso.
            </p>
        </section>
    </ng-template>

    <div class="catalog-page__content">
        <section class="catalog-page__surface">
            <div class="catalog-page__surface-head">
                <div class="catalog-page__surface-copy">
                    <div class="catalog-page__eyebrow">Produtos</div>
                    <h2>Catálogo de produtos</h2>
                    <p>Escolha os artigos que pretende incluir no pedido de orçamento.</p>
                </div>

                <button
                    type="button"
                    class="catalog-page__summary-button"
                    (click)="toggleQuoteSidebar()">
                    <mat-icon
                        [ngClass]="{ 'animate-cart-bounce': cartShouldBounce }"
                        (animationend)="cartShouldBounce = false">
                        shopping_cart
                    </mat-icon>
                    <span>{{ quoteItemsCount }} item{{ quoteItemsCount === 1 ? '' : 's' }}</span>
                </button>
            </div>

            <div class="catalog-page__loading" *ngIf="isLoading; else productsContent">
                <mat-spinner></mat-spinner>
            </div>

            <ng-template #productsContent>
                <div class="catalog-page__empty" *ngIf="products.length === 0">
                    <h3>Sem produtos disponíveis</h3>
                    <p>Não existem produtos disponíveis no catálogo neste momento.</p>
                </div>

                <div class="catalog-page__grid" *ngIf="products.length > 0">
                    <article class="catalog-card" *ngFor="let product of products; let i = index; trackBy: trackByProduct">
                        <div class="catalog-card__media">
                            <img
                                [src]="product.images[0]"
                                alt="{{ product.name }}"
                                class="catalog-card__image"
                                (click)="openGallery(product)"/>

                            <button
                                type="button"
                                class="catalog-card__zoom"
                                (click)="openGallery(product)"
                                title="Ver imagens"
                                aria-label="Ver galeria de imagens">
                                <mat-icon>zoom_in</mat-icon>
                            </button>

                            <div *ngIf="product.images?.length > 1" class="catalog-card__image-count">
                                {{ product.images.length }} fotos
                            </div>
                        </div>

                        <div class="catalog-card__body">
                            <h3>{{ product.name }}</h3>
                            <p>{{ product.description }}</p>
                        </div>

                        <div class="catalog-card__footer">
                            <label class="catalog-card__qty-label" for="qty-{{ i }}">Quantidade</label>
                            <div class="catalog-card__actions-row">
                                <input id="qty-{{ i }}" type="number" [(ngModel)]="product.quantity" class="catalog-card__qty-input" min="1"/>

                                <div *ngIf="product.addedToQuote" class="catalog-card__success">
                                    <div class="catalog-card__success-badge animate-pop-check">
                                        <mat-icon>check</mat-icon>
                                    </div>
                                </div>

                                <button
                                    *ngIf="!product.addedToQuote"
                                    type="button"
                                    class="catalog-card__add-button"
                                    (click)="handleAddToQuote(product)">
                                    Adicionar ao orçamento
                                </button>
                            </div>
                        </div>
                    </article>
                </div>
            </ng-template>
        </section>
    </div>

    <button
        type="button"
        (click)="toggleQuoteSidebar()"
        class="catalog-page__floating-cart"
        aria-label="Ver orçamento">
        <mat-icon>shopping_cart</mat-icon>
        <span class="catalog-page__floating-badge">{{ quoteItemsCount }}</span>
    </button>

    <div class="catalog-page__sidebar-backdrop" *ngIf="quoteSidebarOpen" (click)="toggleQuoteSidebar()"></div>

    <aside
        class="catalog-sidebar"
        [ngClass]="{ 'catalog-sidebar--open': quoteSidebarOpen }">
        <div class="catalog-sidebar__head">
            <div>
                <div class="catalog-page__eyebrow">Orçamento</div>
                <h2>Resumo do pedido</h2>
            </div>

            <button type="button" class="catalog-sidebar__close" (click)="toggleQuoteSidebar()" aria-label="Fechar">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="catalog-sidebar__items" *ngIf="quoteItems.length > 0; else emptyCart">
            <article *ngFor="let item of quoteItems; let i = index" class="catalog-sidebar__item">
                <div class="catalog-sidebar__item-top">
                    <div class="catalog-sidebar__item-main">
                        <img
                            *ngIf="item.images?.[0]"
                            [src]="item.images[0]"
                            alt="{{ item.name }}"
                            class="catalog-sidebar__item-image"/>
                        <div>
                            <h3>{{ item.name }}</h3>
                        </div>
                    </div>

                    <button type="button" class="catalog-sidebar__remove" (click)="removeItem(i)" aria-label="Remover item">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>

                <div class="catalog-sidebar__item-qty">
                    <label>Quantidade</label>
                    <input
                        type="number"
                        [(ngModel)]="item.quantity"
                        class="catalog-sidebar__qty-input"
                        min="1"
                        (change)="updateTotal()"/>
                </div>
            </article>
        </div>

        <ng-template #emptyCart>
            <div class="catalog-sidebar__empty">
                <h3>Nenhum produto adicionado</h3>
                <p>Escolha os artigos do catálogo para montar o pedido de orçamento.</p>
            </div>
        </ng-template>

        <div class="catalog-sidebar__footer">
            <div class="catalog-sidebar__total">
                <span>Total de itens</span>
                <strong>{{ getTotalQuantity() }}</strong>
            </div>

            <button
                type="button"
                class="catalog-sidebar__submit"
                [disabled]="quoteItems.length === 0"
                (click)="navigateToQuote()">
                Pedir orçamento
            </button>
        </div>
    </aside>
</div>

<!-- Image Modal -->
<div
    *ngIf="selectedProduct"
    class="catalog-gallery"
>
    <div class="catalog-gallery__dialog">
        <button type="button" (click)="closeGallery()" class="catalog-gallery__close" aria-label="Fechar">
            <mat-icon>close</mat-icon>
        </button>

        <div class="catalog-gallery__counter" *ngIf="selectedProduct.images?.length > 1">
            {{ selectedImageIndex + 1 }} / {{ selectedProduct.images.length }}
        </div>

        <div class="catalog-gallery__viewer">
            <button type="button" (click)="prevImage()" class="catalog-gallery__nav" aria-label="Imagem anterior">
                <mat-icon>chevron_left</mat-icon>
            </button>

            <img
                [src]="selectedProduct.images[selectedImageIndex]"
                alt=""
                class="catalog-gallery__image"/>

            <button type="button" (click)="nextImage()" class="catalog-gallery__nav" aria-label="Imagem seguinte">
                <mat-icon>chevron_right</mat-icon>
            </button>
        </div>
    </div>
</div>
